//Import from project
import { VOID_INVOICE } from "../../../Schema/Invoice";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { useState, useContext } from "react";

const useVoidInvoice = ({ handleCloseDel, setRefetch, id }) => {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [voidInvoice] = useMutation(VOID_INVOICE, {
    onCompleted: ({ voidInvoice }) => {
      // console.log("voidInvoice :", voidInvoice);
      setLoading(false);
      if (voidInvoice?.isSuccess === true) {
        setAlert(true, "success", voidInvoice?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", voidInvoice?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    voidInvoice({
      variables: {
        id,
      },
    });
  };

  return { handleDelete, loading };
};

export default useVoidInvoice;
